import { Component, OnInit, inject } from '@angular/core';
import { AuthenticationService } from '@app/core/services/authentication/authentication.service';
import { WebSocketService } from '@app/services/web-socket/web-socket.service';

@Component({
	selector: 'logout',
	templateUrl: './logout.component.html',
	styleUrls: ['./logout.component.scss'],
	standalone: false
})
export class LogoutComponent implements OnInit {
	private webSocketService = inject(WebSocketService);
	private authenticationService = inject(AuthenticationService);

	ngOnInit(): void {
		this.webSocketService.closeWebSockets();
		this.authenticationService.logout();
	}
}
